import { Stack, styled } from "@mui/material";
import { dynamicListName } from "../classes.js";
const List = styled(Stack, {
  name: dynamicListName,
  slot: "List",
  shouldForwardProp: (prop) => prop !== "ownerState",
  overridesResolver: (_props, styles) => [styles.list]
})``;
export {
  List
};
//# sourceMappingURL=List.js.map
